import React, { Component, PropTypes } from 'react';
import transLoader from '@beisen/i18n-translation-loader';
require('./EmptyIcon.scss');
// 如果父级默认没有给传高度  则调用父级getHeight方法
const defaultTranslation = {
	emptyText: '这里什么都没有...'
};
class EmptyIcon extends Component {
    constructor(props) {
        super(props);
        this.state = {
			containerHeight: props.containerHeight ? props.containerHeight || 0 : 521  //外界容器高度
		};
        this.jointClassName = this.jointClassName.bind(this);
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            emptyText: 'table.emptyText'
          }), props.translation);
	}

	componentDidMount() {
		this.props.getHeight && this.props.getHeight();
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ containerHeight: nextProps.containerHeight });
	}
    //拼接需要引用的class
    jointClassName() {
	  const num = this.props.num || 1;
	  const { containerHeight } = this.state;
	  if(containerHeight > 600) {
			return 'empty_img' + num + '_lg';
	  } else if(containerHeight <= 600 && containerHeight > 300) {
	  		return 'empty_img' + num + '_md';
	  } else if(containerHeight <= 300 && containerHeight > 150) {
	  		return 'empty_img' + num + '_sm';
	  } else if(containerHeight <= 150 && containerHeight != 0) {
			return 'empty_img' + num + '_xs';
	  }
 	}

    render() {
        let style = {
			'height': this.state.containerHeight
		};
		const { translation } = this;

		return(
			<div className="empty-img-container" style={style}>
				<div className={'empty-con ' + this.jointClassName()} >
					<div className="empty-bgimage"></div>
					<span className="empty-text">{this.props.text || translation.emptyText}</span>
				</div>
			</div>
		);

    }
}



module.exports = EmptyIcon;



// WEBPACK FOOTER //
// ./src/components/EmptyIcon/EmptyIcon.js